export enum AchievementTargetTypes {
	EXPLORE_TILES = "exploreTiles",
	SETTLEMENT_CONTROL = "settlementControl",
	HAS_LUMBER_INCOME = "hasLumberIncome",
	HAS_STONE_INCOME = "hasStoneIncome",
	HAS_CLAY_INCOME = "hasClayIncome",
	HAS_IRON_INCOME = "hasIronIncome",
	HAS_GOODS_INCOME = "hasGoodsIncome",
	HAS_STEEL_INCOME = "hasSteelIncome",
	HAS_WORKFORCE = "hasWorkforce",
	HAS_CLICKERS = "hasClickers",
	HAS_ROADS_BUILD = "hasRoadsBuild",
	AD_WATCH = "adWatch",
	HAS_ARMY = "hasArmy",
}
